<template>
	<view class="videoDetails-wrap">
		<view class="videoDetails-main">
			<video class="videoDetails-box" id="myVideo"
				src="https://img.cdn.aliyun.dcloud.net.cn/guide/uniapp/%E7%AC%AC1%E8%AE%B2%EF%BC%88uni-app%E4%BA%A7%E5%93%81%E4%BB%8B%E7%BB%8D%EF%BC%89-%20DCloud%E5%AE%98%E6%96%B9%E8%A7%86%E9%A2%91%E6%95%99%E7%A8%8B@20200317.mp4"
				@error="videoErrorCallback" :danmu-list="danmuList" enable-danmu danmu-btn controls>
			</video>
			<view class="shipin-jieshao-box">
				<text class="name">金隅集团2020年第一季度技术学习</text>
				<text class="time">发布时间 : 2018-07-16</text>
			</view>
			<image @tap="navigateBack" class="backIcon" src="../../../static/icon/backIcon.png" mode="widthFix"></image>
		</view>
		<view class="learn-jilu-main">
			<view class="learn-jilu-box">
				<image class="learn-icon" src="../../../static/icon/learnIcon.png" mode="widthFix"></image>
				<text class="learn-title">学习记录</text>
			</view>
			<view class="learn-jilu-main-inside">
				<view class="content">
					2020.06.10 张三丰获得1.5学时
				</view>
				<view class="content">
					2020.06.10 张三丰获得1.5学时
				</view>
				<view class="content">
					2020.06.10 张三丰获得1.5学时
				</view>
				<view class="content">
					2020.06.10 张三丰获得1.5学时
				</view>
			</view>
		</view>
		
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods: {
			navigateBack() {
				uni.navigateBack()
			}
		}
	}
</script>

<style lang="scss" scoped>
	page{
		background-color: #f2f3f7;
	}
	.videoDetails-main{
		position: relative;
		.backIcon{
			position: absolute;
			left: 20rpx;
			top:20rpx;
			width: 40rpx;
			height: 40rpx;
			z-index: 999;
		}
	}
	.videoDetails-box{
		width: 100%;
		height: 604rpx;
		display: block;
	}
	.shipin-jieshao-box{
		display: flex;
		flex-direction: column;
		width: 100%;
		padding: 40rpx;
		box-sizing: border-box;
		background-color: #fff;
		box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
		.name{
			color: #333333;
			font-size: 36rpx;
		}
		.time{
			color: #999999;
			font-size: 22rpx;
			margin-top: 20rpx;
		}
	}
	.learn-jilu-main{
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: #fff;
		padding: 40rpx 20rpx;
		box-sizing: border-box;
		width: 92%;
	    margin:40rpx auto 0;
		box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
		border-radius: 10rpx;
	}
	.learn-jilu-box{
		display: flex;
		align-items: center;
		.learn-icon{
			width: 40rpx;
			height: 40rpx;
		}
		.learn-title{
			font-size: 28rpx;
			margin-left: 20rpx;
			color: #ff4800;
		}
	}
	.learn-jilu-main-inside{
		display: flex;
		flex-direction: column;
		margin-top: 20rpx;
		.content{
			font-size: 24rpx;
			color: #666666;
			line-height: 2.5;
		}
	}
</style>
